import {Subject} from 'rxjs';

export class CommodityResultService {
  /**
   * 添加资源 选择器 返回值
   */
  public getCommoditySubject = new Subject<any>();
  public getCommodity = this.getCommoditySubject.asObservable();
}
